import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
} from '@mui/material';
import {
  Home,
  ErrorOutline,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { USER_ROLES } from '@/constants/app';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  const handleGoHome = () => {
    if (isAuthenticated && user) {
      // Navigate to dashboard based on user role
      switch (user.role) {
         case USER_ROLES.Booking_Admin:
    case USER_ROLES.Booking_SuperAdmin:
        case USER_ROLES.Booking_Viewer:
        // case USER_ROLES.ACCOUNTANT:
        // case USER_ROLES.TEACHER:
        // case USER_ROLES.STAFF:
        // case USER_ROLES.HELPER:
        // case USER_ROLES.DRIVER:
        // case USER_ROLES.SUPERVISOR:
        // case USER_ROLES.HR:
        // case USER_ROLES.USER_G1:
        // case USER_ROLES.USER_G2:
          navigate('/bookings');
          break;
        // case USER_ROLES.STUDENT:
        // case USER_ROLES.PARENT:
        default:
          navigate('/dashboard/profile');
          break;
      }
    } else {
      navigate('/login');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: 3,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <ErrorOutline
              sx={{
                fontSize: 120,
                color: 'error.main',
                opacity: 0.8,
              }}
            />
          </Box>

          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: '6rem',
              fontWeight: 'bold',
              color: 'primary.main',
              mb: 2,
              lineHeight: 1,
            }}
          >
            404
          </Typography>

          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: 600,
              mb: 3,
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 4,
              maxWidth: 400,
              mx: 'auto',
            }}
          >
            Sorry, the page you are looking for doesn't exist or has been moved.
            Please check the URL or go back to the homepage.
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<Home />}
            onClick={handleGoHome}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
            }}
          >
            Back to Home
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};